import { render, staticRenderFns } from "./onboarding.html?vue&type=template&id=288b9a72&scoped=true&"
import script from "./onboarding.js?vue&type=script&lang=js&"
export * from "./onboarding.js?vue&type=script&lang=js&"
import style0 from "./onboarding.scss?vue&type=style&index=0&id=288b9a72&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288b9a72",
  null
  
)

export default component.exports